import { userLogin } from '../../services/auth-service';
import { getData, saveData, updateData, log } from '../../services/common-service';
import { getTestTimeLimit } from '../../components/assessment/common/task-utility';
import {
	osName,
	osVersion,
	browserName,
	browserVersion,
	isMobile,
	mobileModel
} from "react-device-detect";
// import { logToSentry } from '../../functions';
import * as Sentry from "@sentry/react";
import { specialMessages } from '../../Constants';

export const UPDATE_VALUE = 'common:updateData';
export const SET_USER_DATA = 'common:setUserData';
export const CLEAR_USER_DATA = 'common:clearUserData';
export const GET_DATA = 'common:getData';
export const SET_TASK_RESPONSE = 'common:setTaskResponse';
export const SET_RESP_AT_25MIN = 'common:setRespAt25min';
export const SET_RESP_AT_30MIN = 'common:setRespAt30min';
export const SET_RESP_AT_35MIN = 'common:setRespAt35min';
export const SET_DEMOGRAPHICS_RESPONSE = 'common:setDemographicsResponse';
export const SET_DATE_TIME_START = 'common:setDateTimeStart';
export const SET_SCREEN_DURATION = 'common:setScreenDuration';
export const SET_TERMINATION = 'common:setTermination';
export const SET_ASSESSMENT_STATUS = "common:setAssessmentStatus";
export const REQUEST_START = "common:requestStart";
export const REQUEST_SAVED = "common:requestSaved";
export const REQUEST_ERROR = "common:requestError";
export const REQUEST_END = "common:requestEnd";

const updateValue = (obj) => ({
	type: UPDATE_VALUE,
	obj
})

const setUserData = (userData) => ({
	type: SET_USER_DATA,
	userData
});

const clearUserData = () => ({
	type: CLEAR_USER_DATA
});

const processGetAllData = (data) => ({
	type: GET_DATA,
	data
});

const setDemographicsResponse = (name, value, child = null) => ({
	type: SET_DEMOGRAPHICS_RESPONSE,
	child,
	name,
	value
});

const setTaskResponse = (task, taskType, subTaskType, response, index) => ({
	type: SET_TASK_RESPONSE,
	task,
	taskType,
	subTaskType,
	response,
	index
});

const setRespAt25min = tasks => ({
	type: SET_RESP_AT_25MIN,
	tasks
});

const setRespAt30min = tasks => ({
	type: SET_RESP_AT_30MIN,
	tasks
});

const setRespAt35min = tasks => ({
	type: SET_RESP_AT_35MIN,
	tasks
});

const setDateTimeStart = () => ({
	type: SET_DATE_TIME_START
})

const setScreenDuration = (url, duration) => ({
	type: SET_SCREEN_DURATION,
	url,
	duration
});

const setTermination = (terminationReason) => ({
	type: SET_TERMINATION,
	terminationReason
});

const setAssessmentStatus = (value) => ({
	type: SET_ASSESSMENT_STATUS,
	value: value
});

const requestStart = () => ({
	type: REQUEST_START
});

const requestSaved = () => ({
	type: REQUEST_SAVED
});

const requestError = (error) => ({
	type: REQUEST_ERROR,
	error
});

const requestEnd = () => ({
	type: REQUEST_END
});

export const login = (params, successHandler = null, errorHandler = null) => {
	return (dispatch, getState) => {
		dispatch(requestStart());

		const filterTests = (tests) => {
			const filteredTests = Object.values(tests)
				.filter(test => test.sortOrder !== 0 && test.isCompleted === 0)
				.sort((a, b) => (a.sortOrder - b.sortOrder));

			return !filteredTests.length ? null : filteredTests[0].fullName;
		};

		return userLogin(
			params,
			(response) => {
				if ('success' in response.data) {
					const participant = response.data.success.participant;
					const resumeData = JSON.parse(localStorage.getItem('resumeData'));
					let resume = false;

					if (!!resumeData) {
						const resumeUser = localStorage.getItem('resumeUser');
						const resumeTest = filterTests(resumeData.userData.tests);
						const currentTest = filterTests(participant.tests);
						resume = resumeUser === participant.username && resumeTest === currentTest;
					}

					resume || dispatch(clearUserData());
					dispatch(setUserData(participant));
				}
				if (successHandler) {
					successHandler(response.data);
				}
			},
			(error) => {
				dispatch(requestError(error.response));
				if (errorHandler) {
					errorHandler(error.response);
				}
			},
			() => {
				dispatch(requestEnd());
			}
		);
	};
};

export const getAllData = (task, successHandler = null, errorHandler = null) => {
	return (dispatch, getState) => {
		dispatch(requestStart());

		dispatch(logToSentry('info', 'Successfully requested assessment record from RAP API'))

		return getData(task,
			(response) => {
				dispatch(processGetAllData(response.data));
				dispatch(logToSentry('info', 'Successfully received assessment record from RAP API'))
				if (successHandler) {
					successHandler(response.data);
				}
			},
			(error) => {
				dispatch(requestError(error.response));
				dispatch(logToSentry('error', "", error, {}, {}))
				if (errorHandler) {
					errorHandler(error.response);
				}
			},
			() => {
				dispatch(requestEnd());
			} 
		);
	};
};

export const resumeSession = (data) => {
	return (dispatch, getState) => {
		dispatch(processGetAllData(data));
	};
};

export const save = (testData, returnFunc = () => {}) => {
	return (dispatch, getState) => {
		dispatch(requestStart());
		const participantData = {
			Username: testData.username,
			[testData.testName + 'Complete']: testData.value
		};
		const { data } = getState();
		const saveParams = { params: data };
		const localIpUrl = require('local-ip-url');
		data.operatingSystem = osName + ' ' + osVersion;
		data.browser = browserName + ' ' + browserVersion;
		data.device = isMobile ? mobileModel : osName + ' ' + osVersion;
		data.resumeURL = null;
		data.timeRemaining = null;

		if (testData.value === 1) {
			saveParams.testToUpdate = testData.testName;
		} else if (testData.value === 0) {
			const timeLimit = getTestTimeLimit(data.userData.grade) * 60;
			data.resumeURL = localStorage.getItem('resumeLocation');
			data.timeRemaining = timeLimit - parseFloat(localStorage.getItem('resumeTime'));
		}

		const taskScreens = data.screens.filter(item => !(/Instruction/).test(item.url) && !(/Practice/).test(item.url));
		data.totalItemTimeNoPracticeNoInstruction = taskScreens.map(screen => screen.duration).reduce((a, b) => a + b);
		data.totalAssessmentTime = data.timePerScreen = data.screens.map(screen => screen.duration).reduce((a, b) => a + b);
		data.totalSessionTime = (new Date().getTime() / 1000) - (new Date(data.dateTimeStart).getTime() / 1000);
	
		dispatch(logToSentry('info', 'Requesting save to RAP API', null, {},
		(window.globalConfig.verboseSentryLogging) ? {
			filename: 'localAssessmentData.json',
			data: data
		}: null));

		return saveData(saveParams,
			(response) => {
				dispatch(requestSaved(response.data));
				if (response.data === specialMessages.SaveSuccess) {
					dispatch(logToSentry('info', 'Successfully sent assessment save request to RAP API'))
				} else {
					dispatch(logToSentry('info', response.data))
				}
				return updateData(participantData, (res) => {
					dispatch(setUserData(data.userData));

					returnFunc();
				});			
			},
			(error) => {
				dispatch(requestError(error.message));
				
				dispatch(logToSentry('error', "", error, {},
				{
					filename: 'localAssessmentData.json',
					data: data
				}))

				return saveData(saveParams,
					(response) => {
						dispatch(requestSaved(response.data));
						if (response.data === specialMessages.SaveSuccess) {
							dispatch(logToSentry('info', 'Successfully sent assessment save request to RAP API'))
						} else {
							dispatch(logToSentry('info', response.data))
						}
						return updateData(participantData, (res) => {
							dispatch(setUserData(data.userData));

							returnFunc();
						});			
					},
					(error) => {
						dispatch(requestError(error.message));

						dispatch(logToSentry('error',  "", error, {},
						{
							filename: 'localAssessmentData.json',
							data: data
						}))
						returnFunc();
					},
					() => {
						dispatch(requestEnd());

						returnFunc();
					}
				);
			},
			() => {
				dispatch(requestEnd());

				returnFunc();
			}
		);
	};
};

export const logToRAP = (err) => {
	return (dispatch) => {
		dispatch(requestStart());
		return log(err,
			(response) => {
				dispatch(requestSaved(response.data));
			},
			(error) => {
				dispatch(requestError(error.message));
			},
			() => {
				dispatch(requestEnd());
			});
	}
}

export const logLocal = (err) => {

}

export const logToSentry = (level = 'error', msg = '', exception = null, tags = {}, attachment = null) => {
	return (dispatch, getState) => {
		dispatch(requestStart());

		const { data } = getState(); // get assessment data from the state

		// configure the scope for the error/activity
		Sentry.configureScope(scope => {
			scope.clear(); // clear any existing scope settings
			scope.setLevel(level); // set the level of the error/activity

			// set the user context for the error/activity
			scope.setUser({
				id: data.userData.username,
			})

			// set the assessmentId tag
			tags["assessmentId"] = data.assessmentId ?? null;
			// set the versionId tag
			tags["versionId"] = data.versionID ?? null;
			scope.setTags(tags); // set any other tags
			if (attachment != null) scope.addAttachment(attachment); // attach any data
		})
	
		if (exception) {
			Sentry.captureException(exception);
		} else {
			Sentry.captureMessage(msg);
		}
	}
}

export {
	updateValue,
	setUserData,
	clearUserData,
	setDemographicsResponse,
	setTaskResponse,
	setRespAt25min,
	setRespAt30min,
	setRespAt35min,
	setDateTimeStart,
	setScreenDuration,
	setTermination,
	setAssessmentStatus
}